enum LogLevel {
  LOG = 'log',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
}

interface LogContent {
  sessionId?: string;
}

type LoggerUserData = {
  identityId?: string;
};
let userData: LoggerUserData;

async function sendToSplunk(message: string, level: LogLevel, content?: LogContent) {
  if (import.meta.env.DEV) {
    // Prevent logging to Splunk during local development
    return;
  }

  try {
    const connectApiBaseUrl = import.meta.env.VITE_CONNECT_API_BASE_URL;
    await fetch(`${connectApiBaseUrl}/connect/api/v1/logs`, {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message,
        level,
        formType: 'onboarding-gateway',
        pageUrl: window.location.href,
        sessionId: content?.sessionId,
      }),
    });
  } catch (e) {
    console.error('Failed to send log to Splunk', e);
  }
}

const logger = {
  log: (message: string, content?: LogContent) => {
    message = `${message}, userData: ${JSON.stringify(userData)}`;
    console.log(message, content ?? '');
  },
  info: (message: string, content?: LogContent) => {
    message = `${message}, userData: ${JSON.stringify(userData)}`;
    console.info(message, content ?? '');
    sendToSplunk(message, LogLevel.INFO, content);
  },
  warn: (message: string, content?: LogContent) => {
    message = `${message}, userData: ${JSON.stringify(userData)}`;
    console.warn(message, content ?? '');
    sendToSplunk(message, LogLevel.WARN, content);
  },
  error: (message: string, content?: LogContent) => {
    message = `${message}, userData: ${JSON.stringify(userData)}`;
    console.error(message, content ?? '');
    sendToSplunk(message, LogLevel.ERROR, content);
  },
  setUserData: (data: LoggerUserData) => {
    userData = data;
  },
};
export default logger;
